"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const Concatenation_1 = require("../../../data/utilities/Concatenation");
const highlight_1 = require("../../highlight");
const SignalDeltaLine_1 = __importDefault(require("../SignalDeltaLine"));
function SignalCrosshair({ signal }) {
    const highlightIDsX = (0, react_1.useMemo)(() => {
        return [(0, Concatenation_1.buildID)(signal.id, 'Crosshair'), (0, Concatenation_1.buildID)(signal.id, 'Crosshair_X')];
    }, [signal.id]);
    const highlightIDsY = (0, react_1.useMemo)(() => {
        return [(0, Concatenation_1.buildID)(signal.id, 'Crosshair'), (0, Concatenation_1.buildID)(signal.id, 'Crosshair_Y')];
    }, [signal.id]);
    const highlightX = (0, highlight_1.useHighlight)(highlightIDsX);
    const highlightY = (0, highlight_1.useHighlight)(highlightIDsY);
    const highlight = (0, highlight_1.useHighlight)([signal.id]);
    if (!signal?.x?.delta || !signal?.y?.delta)
        return null;
    return ((0, jsx_runtime_1.jsxs)("g", { children: [(0, jsx_runtime_1.jsx)(SignalDeltaLine_1.default, { delta: signal.x.delta, axis: "X", show: highlightX.isActive || highlight.isActive }), (0, jsx_runtime_1.jsx)(SignalDeltaLine_1.default, { delta: signal.y.delta, axis: "Y", show: highlightY.isActive || highlight.isActive })] }));
}
exports.default = SignalCrosshair;
